module.exports = __webpack_public_path__ + "img/image_sun_color.1f112e07.png";